import type { ReactNode } from "react";
import { useState } from "react";

type Tone = "default" | "danger";

interface Props {
  children: ReactNode;
  onClick: () => void;
  tone?: Tone;
  "data-testid"?: string;
}

const TONES: Record<Tone, { color: string; hover: string }> = {
  default: { color: "var(--ink-3)", hover: "var(--bg-2)" },
  danger: { color: "var(--bad)", hover: "rgba(177, 75, 54, 0.1)" },
};

export function IconButton({
  children,
  onClick,
  tone = "default",
  "data-testid": testId,
}: Props) {
  const [hovered, setHovered] = useState(false);
  const { color, hover } = TONES[tone];

  return (
    <button
      data-testid={testId}
      type="button"
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: 28,
        height: 28,
        borderRadius: 8,
        background: hovered ? hover : "transparent",
        color,
        transition: "background 0.15s",
        flexShrink: 0,
      }}
    >
      {children}
    </button>
  );
}
